import createBreakpoint from 'shared-tokens/utils/breakpoints';
import createTransition from 'shared-tokens/utils/createTransition';
import spacings from 'shared-tokens/utils/tokens/spacings';

export const mainCls = 'modal-body';
const brXs = createBreakpoint('xs');
const brS = createBreakpoint('s');

export default {
    [mainCls]: {
        padding: `0 ${spacings.s}px ${spacings.s}px`,
        willChange: 'padding, margin-top',
        transition: createTransition(['padding', 'margin']),

        [brXs]: {
            padding: `0 ${spacings.m}px ${spacings.m}px`,
        },
    },

    [`${mainCls}--full`]: {
        padding: 0,
    },
    [`${mainCls}--fullscr`]: {
        padding: 0,
        height: '100%',
    },
    [`${mainCls}--DS`]: {
        [`&.${mainCls}--full`]: {
            padding: `0 !important`,
        },
        [brS]: {
            margin: 0,
            paddingRight: 24,
            paddingLeft: 24,
            minHeight: 302,
            // '&::-webkit-scrollbar': {
            //     width: 16,
            //   },
            // '&::-webkit-scrollbar-track': {
            //     backgroundColor: '#FFF',
            // },
            // '&::-webkit-scrollbar-thumb': {
            //     backgroundColor: '#d8dbdf',
            //     borderRadius: 20,
            //     border: '4px solid transparent',
            //     backgroundClip: 'content-box',
            // },
            // '&::-webkit-scrollbar-thumb:hover': {
            //     backgroundColor: '#96A1B0',
            // }
        },
    },
    [`${mainCls}__title--DS`]: {
        fontSize: 24,
        [brS]: {
            display: 'none',
        },
    },
    [`${mainCls}__btns`]: {
        [brS]: {
            margin: '0 auto',
            maxWidth: 382,
        },
    },
}
